export { default as ZoomView } from './view'
export type { Props as ZoomViewProps, ZoomValue } from './view'
